import React, { useContext, useState } from "react";
import classNames from "classnames";
import { currencyFormat } from "../../util/i18n.js";

import Button from "../../components/button/ButtonController.jsx";
import { GlobalContext } from "../../globals/globalContext.jsx";
import "./styles.styl";
import { useIntl } from "react-intl";

export default function CartOrderBar(props) {
  const intl = useIntl();
  const { delivery, onSubmit, hasBeenClicked, colorSecondary, isStaff } = props;
  const { reRender, setRender } = useContext(GlobalContext);
  const {
    editable,
    sold,
    under_minimum_sale_price,
    is_private,
    get_next_editable_cart_url,
    remaining_to_min_sale_price,
  } = delivery;
  const incl_excl = is_private
    ? intl.formatMessage({ id: "inclusive" })
    : intl.formatMessage({ id: "exclusive" });
  const mwst_text = intl.formatMessage(
    { id: "vatText" },
    { incl_excl: incl_excl },
  );
  const has_orders_with_amount = delivery.orders.filter(
    (item) => item.num_portions_in_cart > 0,
  ).length;
  const under_min_sales_price_cond =
    under_minimum_sale_price && has_orders_with_amount;
  const cancel_cond = !has_orders_with_amount && delivery.sold_and_edited;
  const pause_cond = !sold && !has_orders_with_amount;

  const isDisabled = Boolean(
    !editable ||
    under_min_sales_price_cond ||
    (sold && !delivery.sold_and_edited) ||
    (pause_cond && !delivery.subscription.auto_buy)
  );

  const min_sale_price_text = intl.formatMessage(
    { id: "minSalesPriceText" },
    {
      remaining_to_min_sale_price: currencyFormat(remaining_to_min_sale_price),
    },
  );

  const sale_status_dependent_label =
    sold || delivery.sales_date
      ? intl.formatMessage({ id: "editOrder" })
      : intl.formatMessage({ id: "order" });
  const cancel_label = intl.formatMessage({ id: "cancel" });
  const loading_label = intl.formatMessage({ id: "processing" });
  const pause_label =
    pause_cond && delivery.subscription.auto_buy
      ? intl.formatMessage({ id: "pause" })
      : intl.formatMessage({ id: "order" });
  const past_ordering_time_label = sold
    ? intl.formatMessage({ id: "ordered" })
    : intl.formatMessage({ id: "cartNotOrdered" });

  let label;
  if (editable) {
    label = under_min_sales_price_cond
      ? min_sale_price_text
      : cancel_cond
      ? cancel_label
      : pause_cond
      ? pause_label
      : hasBeenClicked
      ? loading_label
      : sale_status_dependent_label;
  } else {
    label = past_ordering_time_label;
  }
  const handleClick = () => {
    onSubmit();
    setRender(!reRender);
  };
  const isMobile = window.innerWidth < 940;
  return (
    <div
      className={classNames("cart-order-bar", {
        "cart-order-bar-mobile": isMobile,
      })}
    >
      <div className="cart-order-bar__submit">
        <Button
          secondary={!editable}
          onClick={handleClick}
          confirm={false}
          label={label}
          disabled={isDisabled}
        />
      </div>
      <div className="cart-order-bar__bottom">
        <div className={classNames("cart-order-bar__message", {
          "cart-order-bar__message--with-back-link": isStaff
        })}>
          {mwst_text}
        </div>
        {isStaff && (
          <div className="cart-order-bar__back-link">
            <a href="/" className="back-to-muli-link">
              <span className="back-arrow">←</span>
              <span className="back-text">
                {intl.formatMessage({ id: "backToMuli" }, { default: "back to MULI" })}
              </span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
